// extracted by mini-css-extract-plugin
export default {"transaction":"TransactionIcon_transaction__hpy6V"};